/**
 * Resolves which utm_* values to attach to a dashboard redirect.
 *
 * If any of utm_source / utm_medium / utm_campaign is already present on the
 * current page's URL, those present values are forwarded as-is and nothing
 * else is filled in (e.g. utm_medium present but no utm_source → only
 * utm_medium is sent, no default source is added). Only when none of the
 * three are present on the page does `defaults` apply.
 *
 * @param {Record<string, any>} [query] - e.g. router.query
 * @param {{ source?: string, medium?: string, campaign?: string }} [defaults]
 */
export const resolveUtmParams = (query = {}, defaults = {}) => {
  const present = {
    source: query.utm_source || undefined,
    medium: query.utm_medium || undefined,
    campaign: query.utm_campaign || undefined,
  };

  if (present.source || present.medium || present.campaign) {
    return present;
  }

  return defaults;
};

/**
 * Appends utm_source / utm_medium / utm_campaign query params to a URL.
 * Only the keys actually provided are appended — no implicit defaults here;
 * pair with `resolveUtmParams` to decide what to pass in.
 *
 * @param {string} url
 * @param {{ source?: string, medium?: string, campaign?: string }} [utm]
 * @returns {string}
 */
export const appendUtmParams = (url, { source, medium, campaign } = {}) => {
  const separator = url.includes("?") ? "&" : "?";
  const params = new URLSearchParams();

  if (source) params.set("utm_source", source);
  if (medium) params.set("utm_medium", medium);
  if (campaign) params.set("utm_campaign", campaign);

  const query = params.toString();
  return query ? `${url}${separator}${query}` : url;
};
